import React from 'react';
import { GripHorizontal, X } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * DraggablePaneWrapper Component
 * Wraps pane content with drag handle and remove button
 */
const DraggablePaneWrapper = ({ 
  paneId,
  paneLabel,
  children,
  isDragging = false,
  isDraggedOver = false,
  onDragStart,
  onDragEnd,
  onDragOver,
  onDragEnter,
  onDrop,
  onRemove,
  canRemove = true
}) => {
  return (
    <div
      onDragOver={onDragOver}
      onDragEnter={onDragEnter}
      onDrop={onDrop}
      className={`h-full rounded-lg border-2 transition-all ${
        isDragging 
          ? 'opacity-50 border-purple-500 scale-95' 
          : isDraggedOver
          ? 'border-purple-500 border-dashed bg-purple-50 dark:bg-purple-900/20'
          : 'border-slate-200 dark:border-slate-700'
      }`}
    >
      {/* Drag Handle Header */}
      <div
        draggable
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        className="bg-slate-50 dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700 px-3 py-2 flex items-center justify-between cursor-move group"
      >
        <div className="flex items-center gap-2">
          <GripHorizontal className="w-4 h-4 text-slate-400 group-hover:text-purple-500 transition-colors" />
          <span className="text-sm font-medium text-slate-700 dark:text-slate-300">
            {paneLabel}
          </span>
        </div>
        
        {canRemove && (
          <Button
            variant="ghost"
            size="sm"
            onClick={(e) => {
              e.stopPropagation();
              onRemove?.(paneId);
            }}
            className="h-6 w-6 p-0 opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-100 dark:hover:bg-red-900/30"
            title="Remove pane"
          >
            <X className="w-3 h-3 text-slate-600 dark:text-slate-400" />
          </Button>
        )}
      </div>

      {/* Pane Content */}
      <div className="h-[calc(100%-40px)] overflow-y-auto overflow-x-hidden">
        {children}
      </div>
    </div>
  );
};

export default DraggablePaneWrapper;
